import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const CharacterCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 100%;
    height: 112px;
    padding: 8px;
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_2};
    gap: 8px;
  `}
`;

export const CharacterDetail = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 8px;

    .t {
      color: ${theme.content.content_light_1};
      ${theme.fontStyle.text.body16_medium};
    }

    .desc {
      color: ${theme.content.hierarchy3};
      ${theme.fontStyle.text.body14_regular};
      ${theme.mixins.text.ellipsis_2};
      word-break: break-all;
    }

    .sub {
      display: flex;
      flex: 1;
      align-items: flex-end;
      justify-content: space-between;

      .like {
        display: flex;
        align-items: center;
        color: ${theme.content.content_light_4};
        gap: 4px;
        ${theme.fontStyle.text.body14_regular};
      }
    }
  `}
`;

export const ImageWrapper = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: 80px;
  height: 100%;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
export const CheckboxWrapper = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
`;

export const CreateUserName = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    max-width: 130px;
    padding: 0 4px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.2);
    color: ${theme.content.content_light_1};
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    gap: 8px;
    ${theme.mixins.text.ellipsis_1};
    ${theme.fontStyle.text.caption_medium};
  `}
`;
